// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "partnership-carousel")
// Template updated: templates/public/static/partnership/main-screeen.html.twig (data-lazy-init="slick-slider")

import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
import $ from "jquery";

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

$(document).ready(function(){
    // Wheel-scroll navigation (page-specific UX — guard ensures slick is initialized first)
    $('.work-with__list-carousel').on('wheel', function(e) {
        if (!$(this).hasClass('slick-initialized')) return;
        e.preventDefault();
        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    });

    if ($('.work-with__list-carousel').length) {
        $(".prev-btn").click(function () {
            var $carousel = $(".work-with__list-carousel");
            if (!$carousel.hasClass('slick-initialized')) return;
            $carousel.slick("slickPrev");
        });

        $(".next-btn").click(function () {
            var $carousel = $(".work-with__list-carousel");
            if (!$carousel.hasClass('slick-initialized')) return;
            $carousel.slick("slickNext");
        });

        $(".prev-btn").addClass("slick-disabled");

        $(".work-with__list-carousel").on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
                $(".prev-btn").addClass("slick-disabled");
            } else {
                $(".prev-btn").removeClass("slick-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
                $(".next-btn").addClass("slick-disabled");
            } else {
                $(".next-btn").removeClass("slick-disabled");
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.timeline-item');
    const progressEl = document.querySelector('.timeline-progress');
    const totalItems = items.length;

    // Змінна для зберігання напрямку (up/down)
    let scrollDirection = 'down';
    let lastScrollPos = window.pageYOffset;

    // Відстежуємо скрол, щоб визначити напрямок
    window.addEventListener('scroll', () => {
        const currentScrollPos = window.pageYOffset;
        scrollDirection = (currentScrollPos > lastScrollPos) ? 'down' : 'up';
        lastScrollPos = currentScrollPos;
    });

    // Створюємо IntersectionObserver з порогами 0, 1, 0.1, 1
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const ratio = entry.intersectionRatio;

            // Якщо скролимо вниз => "активуємо" елемент при ratio >= 1
            // Якщо скролимо вгору => "активуємо" при ratio >= 0.1
            if (scrollDirection === 'down') {
                if (ratio >= 0.7) {
                    entry.target.classList.add('active');
                } else {
                    entry.target.classList.remove('active');
                }
            } else {
                if (ratio >= 1) {
                    entry.target.classList.add('active');
                } else {
                    entry.target.classList.remove('active');
                }
            }
        });
        // Після зміни станів оновлюємо прогрес
        updateProgress();
    }, {
        threshold: [0, 0.7, 1, 1],
        rootMargin: '-60px 0px 0px 0px'
        // негативний відступ 50px знизу: елемент вважатиметься "повністю видимим"
        // лише коли він повністю "заплив" у viewport ще + 50px від нижньої межі
    });

    // "Спостерігаємо" за кожним .timeline-item
    items.forEach(item => {
        observer.observe(item);
    });

    // Функція оновлення прогресу
    function updateProgress() {
        const activeItems = document.querySelectorAll('.timeline-item.active');
        const activeCount = activeItems.length;
        const progressPercent = (activeCount / totalItems) * 100;
        progressEl.style.height = `${progressPercent}%`;
    }
});

